import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getRegion } from 'store/region';

import { Contact } from 'components';

export const ContactContainer = ({ region }) => <Contact region={region} />;

ContactContainer.propTypes = {
  region: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  region: getRegion(state)
});

export default connect(mapStateToProps)(ContactContainer);



// WEBPACK FOOTER //
// ./src/containers/ContactContainer/ContactContainer.js